// Fresh.js
import React, { useState, useEffect } from 'react';
import API from '../api';

function Fresh() {
  const [allowedDeps, setAllowedDeps] = useState([]);
  const [selectedDeps, setSelectedDeps] = useState([]);
  const [antePriorite, setAntePriorite] = useState("7j");
  const [credits, setCredits] = useState(0);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [extractionStatus, setExtractionStatus] = useState('idle'); // 'idle', 'loading', 'complete'
  const [downloadUrl, setDownloadUrl] = useState('');
  const [extractionProgress, setExtractionProgress] = useState(0);
  const [statusCheckInterval, setStatusCheckInterval] = useState(null);
  const [extractionHistory, setExtractionHistory] = useState([]);
  const [licenseStatus, setLicenseStatus] = useState(""); // Ajout du statut de la licence

  // ENRICHISSEMENT DÉSACTIVÉ TEMPORAIREMENT
  // const [enrich, setEnrich] = useState(false);
  // const [maxEnrichCount, setMaxEnrichCount] = useState(100);
  const enrich = false;
  const maxEnrichCount = 0;

  useEffect(() => {
    API.get('/api/auth/user-info')
      .then((res) => {
        const user = res.data;
        if (user.departementsAutorises && user.departementsAutorises.length > 0) {
          const formattedDeps = user.departementsAutorises.map(dep => dep.toString());
          setAllowedDeps(formattedDeps);
        }
        setCredits(user.credits || 0);
        setLicenseStatus(user.licenseStatus || "");
      })
      .catch((err) => console.error(err));
      
    // Charger l'historique des extractions au chargement initial
    loadExtractionHistory();
  }, []);
  
  // Fonction pour charger l'historique des extractions FRESH
  const loadExtractionHistory = async () => {
    try {
      const response = await API.get('/api/extraction/history/fresh');
      setExtractionHistory(response.data);
    } catch (err) {
      console.error("Erreur lors du chargement de l'historique des extractions:", err);
    }
  };
  
  useEffect(() => {
    // Set up regular status checking when extraction is loading
    if (extractionStatus === 'loading') {
      // Clear any existing interval
      if (statusCheckInterval) {
        clearInterval(statusCheckInterval);
      }
      
      // Create new interval for status checks every 1 second
      const interval = setInterval(() => {
        checkFileStatus();
      }, 1000); // Changé de 3000 à 1000 pour rafraîchir chaque seconde
      
      setStatusCheckInterval(interval);
      
      // Immediately check status once
      checkFileStatus();
    } else {
      // Clear interval when extraction is not loading
      if (statusCheckInterval) {
        clearInterval(statusCheckInterval);
        setStatusCheckInterval(null);
      }
    }
    
    // Cleanup interval on component unmount or status change
    return () => {
      if (statusCheckInterval) {
        clearInterval(statusCheckInterval);
      }
    };
  }, [extractionStatus, result]);
  
  // Recharger l'historique après une extraction réussie
  useEffect(() => {
    if (extractionStatus === 'complete') {
      loadExtractionHistory();
    }
  }, [extractionStatus]);

  const checkFileStatus = async () => {
    if (!result || !result.job_id) return;
  
    try {
      const response = await API.get(`/api/extraction/status/${result.job_id}`);
  
      // Mettre à jour la progression progressivement
      setExtractionProgress(prev => {
        // si l’extraction est terminée, on force 100 %
        if (response.data.status === 'complete') {
          return 100;
        }
        // on récupère la valeur serveur (max 99 pour ne pas atteindre 100 avant le status complete)
        const serverP = Math.min(response.data.progress || 0, 99);
        // si prev ≥ server, on incrémente de 1, sinon on « rattrape » serverP
        return prev >= serverP ? Math.min(prev + 1, 99) : serverP;
      });
  
      // Traiter différents statuts possibles
      if (response.data.status === 'complete') {
        setExtractionStatus('complete');
        if (response.data.download_url) {
          setDownloadUrl(response.data.download_url);
          await refreshKPI();
        } else {
          setError("URL de téléchargement non disponible. Veuillez contacter le support.");
        }
      } else if (response.data.status === 'no_data') {
        setExtractionStatus('idle');
        setError("Aucune donnée trouvée pour les critères sélectionnés.");
      } else if (response.data.status === 'failed') {
        setError(response.data.error || "Erreur lors de l'extraction. Veuillez réessayer.");
        setExtractionStatus('idle');
      }
  
      // Si une URL est disponible malgré un statut différent de 'complete'
      if (response.data.download_url && extractionStatus !== 'complete') {
        setDownloadUrl(response.data.download_url);
      }
    } catch (err) {
      console.error("Erreur lors de la vérification de l'état du fichier:", err);
    }
  };

  const refreshKPI = async () => {
    try {
      const response = await API.get('/api/kpi');
      console.log("KPI loaded:", response.data);
      // Si besoin, tu peux stocker les KPI dans un état local pour affichage
    } catch (error) {
      console.error("Erreur lors du chargement des KPI:", error);
    }
  };

  const handleDepChange = (e) => {
    const dep = e.target.value;
    if (e.target.checked) {
      setSelectedDeps([...selectedDeps, dep]);
    } else {
      setSelectedDeps(selectedDeps.filter(item => item !== dep));
    }
  };

  // ENRICHISSEMENT DÉSACTIVÉ TEMPORAIREMENT
  // const handleEnrichmentWarnings = () => {
  //   const timeWarning = window.confirm("Attention, l'enrichissement peut prendre environ 15 minutes pour 500 enregistrements. Continuer ?");
  //   if (!timeWarning) return false;
    
  //   if (maxEnrichCount > credits) {
  //     const proceed = window.confirm("Le nombre d'enrichissements demandé dépasse vos crédits disponibles. Poursuivre avec seulement " + credits + " enrichissements ?\nCliquez sur OK pour ajuster, ou Annuler pour ne pas activer l'enrichissement.");
  //     if (proceed) {
  //       setMaxEnrichCount(credits);
  //       return true;
  //     } else {
  //       const cancelEnrich = window.confirm("Voulez-vous annuler complètement l'opération (ou générer l'extraction sans enrichissement) ? Cliquez sur OK pour annuler l'enrichissement, ou Annuler pour annuler l'opération.");
  //       if (cancelEnrich) {
  //         setEnrich(false);
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     }
  //   }
  //   return true;
  // };

  const handleExtraction = async () => {
    if (selectedDeps.length === 0) {
      setError("Veuillez sélectionner au moins un département.");
      return;
    }
    // ENRICHISSEMENT DÉSACTIVÉ TEMPORAIREMENT
    // if (enrich && !handleEnrichmentWarnings()) return;
    
    if (extractionStatus === 'loading') {
      setError("Une extraction est déjà en cours. Veuillez patienter.");
      return;
    }
    
    setError("");
    setExtractionStatus('loading');
    setDownloadUrl('');
    setExtractionProgress(0);
    
    try {
      const response = await API.post('/api/extraction/fresh', {
        deps_list: selectedDeps,
        days: antePriorite === "7j" ? 7 : antePriorite === "30j" ? 30 : 60,
      });
      setResult(response.data);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (err.response?.status === 403 && detail?.includes("Limite démo")) {
        setError(detail);
      } else {
        setError("Erreur lors de l'extraction F.R.E.S.H.");
      }
      setExtractionStatus('idle');
    }
  };

  const handleDownload = async () => {
    if (!result || !result.job_id) {
      setError("Identifiant de tâche non disponible. Veuillez réessayer.");
      return;
    }
    
    try {
      // Utiliser l'endpoint proxy du backend
      const response = await API.get(`/api/extraction/download/${result.job_id}`, {
        responseType: 'blob',
      });
      
      // Vérification que la réponse contient des données
      if (!response.data || response.data.size === 0) {
        throw new Error("Le fichier téléchargé est vide");
      }
      
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      
      // Récupérer le nom de fichier de l'en-tête Content-Disposition ou utiliser un nom par défaut
      let fileName = `FRESH_export_${new Date().toISOString().slice(0, 10)}.xlsx`;
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      window.URL.revokeObjectURL(blobUrl);
      
    } catch (error) {
      console.error("Erreur lors du téléchargement:", error);
      setError("Erreur lors du téléchargement du fichier. Veuillez réessayer.");
    }
  };

  // Fonction pour télécharger un fichier historique
  const downloadHistoryFile = async (jobId) => {
    try {
      const response = await API.get(`/api/extraction/download/${jobId}`, {
        responseType: 'blob',
      });
      
      if (!response.data || response.data.size === 0) {
        throw new Error("Le fichier téléchargé est vide");
      }
      
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      
      let fileName = `FRESH_export_${new Date().toISOString().slice(0, 10)}.xlsx`;
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Erreur lors du téléchargement du fichier historique:", error);
      setError("Erreur lors du téléchargement du fichier historique. Veuillez réessayer.");
    }
  };

  // Formater la date pour l'affichage
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('fr-FR');
  };

  const isLinkExpired = (timestamp) => {
    if (!timestamp) return true;
    const extractionDate = new Date(timestamp);
    const currentDate = new Date();
    const diffHours = (currentDate - extractionDate) / (1000 * 60 * 60);
    return diffHours > 24;
  };

  const isDemo = licenseStatus === "Demo";

  return (
    <div className="fresh-container">
      <h2>Extraction F.R.E.S.H</h2>
      {/* Message pour la licence Demo */}
      {isDemo && (
        <div className="demo-warning" style={{
          background: "#fff3cd",
          color: "#856404",
          border: "1px solid #ffeeba",
          borderRadius: "5px",
          padding: "15px",
          marginBottom: "20px"
        }}>
          <strong>Mode démo activé :</strong> Vous ne pouvez accéder qu'à des fonctionalités limitées.<br />
          Pour débloquer toutes les fonctionnalités, <a href="https://www.leadxplore.fr/subscribe.html" target="_blank" rel="noopener noreferrer">rendez-vous sur la page de souscription</a>.
        </div>
      )}
      {error && <p className="error">{error}</p>}
      <div className="form-group">
        <label>Départements autorisés :</label>
        <div className="checkbox-group">
          {allowedDeps.length > 0 ? (
            allowedDeps.map((dep) => (
              <label key={dep} className="checkbox-label">
                <input 
                  type="checkbox" 
                  value={dep} 
                  onChange={handleDepChange} 
                  checked={selectedDeps.includes(dep)}
                  disabled={extractionStatus === 'loading'}
                />
                {dep}
              </label>
            ))
          ) : (
            <p>Aucun département autorisé disponible.</p>
          )}
        </div>
      </div>
      <div className="form-group">
        <label>Période d'extraction :</label>
        <select 
          value={antePriorite} 
          onChange={e => setAntePriorite(e.target.value)}
          disabled={extractionStatus === 'loading'}
        >
          <option value="7j">7 jours</option>
          <option value="30j">30 jours</option>
          <option value="60j">60 jours</option>
        </select>
      </div>
      
      {/* ENRICHISSEMENT DÉSACTIVÉ TEMPORAIREMENT (UI) */}
      {/* <div className="form-group">
        <label>
          <input 
            type="checkbox" 
            checked={enrich} 
            onChange={e => setEnrich(e.target.checked)} 
            disabled={extractionStatus === 'loading'}
          />
          Activer l'enrichissement
        </label>
      </div>
      {enrich && (
        <div className="form-group">
          <label>Nombre maximum d'enrichissements :</label>
          <input 
            type="number" 
            value={maxEnrichCount} 
            onChange={e => setMaxEnrichCount(Number(e.target.value))} 
            min="1"
            disabled={extractionStatus === 'loading'}
          />
        </div>
      )} */}

      {/* Ajout de la case à cocher enrichissement */}
      <div className="form-group">
        <label>
          <input
            type="checkbox"
            disabled
            style={{ marginRight: 8 }}
          />
          Activer l'enrichissement
          {licenseStatus === "Demo" && (
            <span style={{ color: "#888", marginLeft: 8 }}>(désactivé en mode demo)</span>
          )}
        </label>
      </div>

      
      <div className="extraction-controls">
        <button 
          className="action-button" 
          onClick={handleExtraction}
          disabled={extractionStatus === 'loading'}
        >
          {extractionStatus === 'loading' ? 'Extraction en cours...' : 'Lancer l\'extraction'}
        </button>
        
        {extractionStatus === 'loading' && (
          <div className="timer">
            <p>Progression : {Math.round(extractionProgress)}%</p>
            <div className="progress-container">
              <div 
                className="progress-bar" 
                style={{ width: `${extractionProgress}%` }}
              >
                <span className="progress-text">{Math.round(extractionProgress)}%</span>
              </div>
            </div>
          </div>
        )}
        
        {extractionStatus === 'complete' && downloadUrl && (
          <button 
            className="download-button" 
            onClick={handleDownload}
          >
            Télécharger le fichier
          </button>
        )}
      </div>

      {/* Historique des extractions */}
      <div className="extraction-history">
        <h3>Historique des extractions F.R.E.S.H (liens valides 24h !)</h3>
        {extractionHistory.length > 0 ? (
          <table className="history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Départements</th>
                <th>Nombre de leads</th>
                <th>Téléchargement</th>
              </tr>
            </thead>
            <tbody>
              {extractionHistory.map((item, index) => (
                <tr key={index}>
                  <td>{formatDate(item.timestamp)}</td>
                  <td>{Array.isArray(item.deps_or_codes) ? item.deps_or_codes.join(', ') : item.deps_or_codes}</td>
                  <td>{item.count || 0}</td>
                  <td>
                      {item.job_id ? (
                        isLinkExpired(item.timestamp) ? (
                          <button 
                            className="download-button-small expired" 
                            disabled
                          >
                            Lien expiré
                          </button>
                        ) : (
                          <button 
                            className="download-button-small" 
                            onClick={() => downloadHistoryFile(item.job_id)}
                          >
                            Télécharger
                          </button>
                        )
                      ) : (
                        "Non disponible"
                      )}
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>Aucun historique d'extraction disponible.</p>
        )}
      </div>
    </div>
  );
}

export default Fresh;
